window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.customMedia = {
  '--sm-up': '(min-width: 576px)',
  '--md-up': '(min-width: 768px)',
  '--lg-up': '(min-width: 992px)',
  '--xl-up': '(min-width: 1200px)',
  '--xxl-up': '(min-width: 1400px)',
  '--xxxl-up': '(min-width: 1500px)',
  '--xs-max-down': '(max-width: 575.98px)',
  '--sm-max-down': '(max-width: 767.98px)',
  '--md-max-down': '(max-width: 991.98px)',
  '--lg-max-down': '(max-width: 1199.98px)',
  '--xl-max-down': '(max-width: 1399.98px)',
  '--xxl-max-down': '(max-width: 1499.98px)',
};
